var render = function render(){var _vm=this,_c=_vm._self._c;return _c('general-text-field',{attrs:{"label":"Name","dense":"","autofocus":"","disabled":_vm.isImmutable},model:{value:(_vm.$_name),callback:function ($$v) {_vm.$_name=$$v},expression:"$_name"}})
}
var staticRenderFns = []

export { render, staticRenderFns }